import { IDeThiChangeQuestionRequest } from "../../../model/request/de-thi/IDeThiChangeQuestionRequest";
import { IDeThiProgressRequest } from "../../../model/request/de-thi/IDeThiProgressRequest";
import { ISMT_DeThi_Sub_Vm } from "../../../model/respone/de-thi/ISMT_DeThi_Sub";
import {
  ISMT_DeThi_Vm,
  ISMT_XemDeThi,
} from "../../../model/respone/de-thi/ISMT_DeThi_Vm";
import { ITongHopTheoDotResponse } from "../../../model/respone/de-thi/ITongHopTheoDotResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ITongHopTheoDotRequest } from "./../../../model/request/de-thi/ITongHopTheoDotRequest";

export interface IDeThi_CauHoi {
  id_dethi: number;
  data: ISMT_DeThi_Sub_Vm;
  data_change: ISMT_DeThi_Sub_Vm;
}

export const eDeThiActionsObj = {
  LOAD_START: {} as any,
  LOAD_SUCCESS: {} as ISMT_DeThi_Vm[],
  LOAD_ERRR: "",

  SAVE_START: {} as ISMT_DeThi_Vm,
  SAVE_SUCCESS: {} as ISMT_DeThi_Vm,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_DeThi_Vm,
  CLOSE_EDIT_MODAL: undefined,

  SHOW_VIEW_DOICAUHOI_MODAL: {} as ISMT_DeThi_Vm,
  CLOSE_VIEW_DOICAUHOI_MODAL: undefined,
  DOICAUHOI_SELECTED: {} as IDeThi_CauHoi,
  CHANGE_QUESTION_START: {} as IDeThiChangeQuestionRequest[],
  CHANGE_QUESTION_SUCCESS: undefined,
  CHANGE_QUESTION_ERROR: "",

  CHANGE_REQUEST: {} as any,
  LOAD_CHITIET_START: 0,
  LOAD_CHITIET_SUCCESS: {} as IDeThi_CauHoi[],
  LOAD_CHITIET_ERROR: "",

  SHOW_PROGRESS_MODAL: {} as number[],
  CLOSE_PROGRESS_MODAL: undefined,

  PROGRESS_START: {} as IDeThiProgressRequest,
  PROGRESS_SUCCESS: undefined,
  PROGRESS_ERROR: "",

  DELETE_MULTIPLE_START: {} as number[],
  DELETE_MULTIPLE_SUCCESS: undefined,
  DELETE_MULTIPLE_ERROR: "",

  SHOW_COMPARE_MODAL: undefined,
  CLOSE_COMPARE_MODAL: undefined,

  ADD_COMPARE: {} as ISMT_DeThi_Vm,
  REMOVE_COMPARE: {} as ISMT_DeThi_Vm,
  REMOVEALL_COMPARE: undefined,

  SHOW_EXAM: {} as ISMT_XemDeThi,
  CLOSE_EXAM: undefined,
  VIEW_EXAM_START: {} as any,
  VIEW_EXAM_SUCCESS: "",
  VIEW_EXAM_ERROR: "",

  PRINT_EXAM_START: "",
  PRINT_EXAM_SUCCESS: undefined,

  LOAD_TONGHOP_START: {} as ITongHopTheoDotRequest,
  LOAD_TONGHOP_SUCCESS: {} as ITongHopTheoDotResponse[],
  LOAD_TONGHOP_ERRR: "",

  EXPORT_TONGHOP_START: {} as ITongHopTheoDotRequest,
  EXPORT_TONGHOP_SUCCESS: undefined,
  EXPORT_TONGHOP_ERRR: "",

  CHANGE_REQUEST_TONGHOP: {} as any,
};
export const eDeThiActionIds = generateActionTypeIds(
  eDeThiActionsObj,
  "DE_THI"
);
export type IDeThiActionTypes = IGenericActionType<
  typeof eDeThiActionsObj,
  "DE_THI"
>;
